<template>
    <div class="container repair-container" v-if="device">

        <!-- Links -->
        <label>What type of photo are you adding?</label>
        <div class="card-grid grid-col-2 mb-0" :class="[pageTitle === 'After' ? 'grid-col-md-3': 'grid-col-md-4']">
            <div class="card-link-container">
                <input type="file" name="frontPhoto" id="frontPhoto" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-front`, 'frontPhoto')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="frontPhoto">
                    <icon-device-front
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-device-front>
                    Front Photo
                </label>
            </div>
            <div class="card-link-container">
                <input type="file" name="backPhoto" id="backPhoto" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-back`, 'backPhoto')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="backPhoto">
                    <icon-device-back
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-device-back>
                    Back Photo
                </label>
            </div>
            <div class="card-link-container">
                <input type="file" name="otherPhoto" id="otherPhoto" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-other`, 'otherPhoto')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="otherPhoto">
                    <icon-camera
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-camera>
                    Other Photo
                </label>
            </div>
            <div class="card-link-container">
                <input type="file" name="esdResults" id="esdResults" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-${esdOrOqc}-results`, 'esdResults')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="esdResults">
                    <icon-checklist
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-checklist>
                    <template v-if="pageTitle === 'Before'">
                        ESD Results
                    </template>
                    <template v-if="pageTitle === 'After'">
                        OQC/Post Repair Diagnostics
                    </template>
                </label>
            </div>
            <div class="card-link-container" v-if="pageTitle === 'Before'">
                <input type="file" name="iqcMri" id="iqcMri" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-iqc-mri`, 'iqcMri')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="iqcMri">
                    <icon-checklist
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-checklist>
                    IQC/MRI
                </label>
            </div>
            <div class="card-link-container" v-if="pageTitle === 'Before'">
                <input type="file" name="irisCodeMatrix" id="irisCodeMatrix" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-iris-code-matrix`, 'irisCodeMatrix')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="irisCodeMatrix">
                    <icon-checklist
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-checklist>
                    IRIS Code Matrix
                </label>
            </div>
            <div class="card-link-container" v-if="pageTitle === 'After'">
                <input type="file" name="fenrirSvc" id="fenrirSvc" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-fenrir-svc`, 'fenrirSvc')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="fenrirSvc">
                    <icon-device-clean
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-device-clean>
                    Fenrir SVC Log
                </label>
            </div>
            <div class="card-link-container" v-if="pageTitle === 'After' && isRefurbOrMailIn">
                <input type="file" name="liveCall" id="liveCall" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-live-call`, 'liveCall')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="liveCall">
                    <icon-mobile
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-mobile>
                    Live Call
                </label>
            </div>
            <div class="card-link-container" v-if="pageTitle === 'After'">
                <input type="file" name="liveCallTest" id="liveCallTest" class="file-input" accept="image/*" capture="environment" @change="uploadPhoto(`${beforeOrAfter}-live-call-test`, 'liveCallTest')">
                <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info" for="liveCallTest">
                    <icon-mobile
                        size="md"
                        class="icon-all-white m-0 mr-2">
                    </icon-mobile>
                    Live Call Test
                </label>
            </div>
        </div>

        <h3 class="mt-4">Uploaded Photos</h3>

        <!-- Upload test results alert -->
        <template v-if="pageTitle === 'Before' && displayBeforeTestBanner">
            <div class="alert alert-warning">
                <animated-warning></animated-warning>
                <div class="alert-content">
                    Please supply a picture of your ESD test results
                </div>
            </div>
        </template>
        <template v-if="pageTitle === 'Before' && displayBeforeIQCMRIBanner">
            <div class="alert alert-warning">
                <animated-warning></animated-warning>
                <div class="alert-content">
                    Please supply a picture of IQC(MRI)/SVC validation or add note to explain why testing could not be done
                </div>
            </div>
        </template>

        <template v-if="pageTitle === 'After'">
            <template v-if="displayAfterTestBanner">
                <div class="alert alert-warning">
                    <animated-warning></animated-warning>
                    <div class="alert-content">
                        Please supply a picture of your OQC/Post Repair Diagnostics results
                    </div>
                </div>
            </template>

            <template v-if="device.make_code === 'samsung' && displayFenrirSVCBanner">
                <div class="alert alert-warning">
                    <animated-warning></animated-warning>
                    <div class="alert-content">
                        Please supply a picture of your Fenrir SVC log
                    </div>
                </div>
            </template>
        </template>

        <!-- Empty State -->
        <div v-if="!imagePaths.length">
            <empty-state
                emptyIcon
                icon="camera"
                title="No photos uploaded"
                subtitle="Select one of the options above to add a photo"
            />
        </div>

        <!-- List of photos -->
        <template>
            <div class="card-grid grid-col-2 grid-col-md-3">
                <image-item
                    v-for="(imagePath, key) in imagePaths" :key="key"
                    :imageType="imagePath.type"
                    :imageData="imagePath.path">
                </image-item>
            </div>
        </template>

        <!-- Footer -->
        <fixed-footer
            v-if="pageTitle === 'Before'"
            :class="{'active': footerActive}"
            :nextLabel="this.nextRepairStep($route.name).title"
            :nextRoute="this.nextRepairStep($route.name).routeName"
            :prevRoute="this.prevRepairStep($route.name).routeName">
        </fixed-footer>
        <!--        <fixed-footer-->
        <!--                v-if="pageTitle === 'After'"-->
        <!--                :class="{'active': showFooter}"-->
        <!--                nextLabel="Samsung Notes"-->
        <!--                nextRoute="repair.samsungNotes">-->
        <!--        </fixed-footer>-->
        <fixed-footer
            v-if="pageTitle === 'After'"
            :class="{'active': footerActive}"
            :nextLabel="this.nextRepairStep($route.name).title"
            :nextRoute="this.nextRepairStep($route.name).routeName"
            :prevRoute="this.prevRepairStep($route.name).routeName">
        </fixed-footer>

        <!-- Image preview modal -->
        <repair-image-modal></repair-image-modal>

    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

// import {firebase} from '@firebase/app';
import '@firebase/storage';
// import { v4 as uuidv4 } from 'uuid';
import Compressor from 'compressorjs';

export default {

    props: ['jobId', 'deviceId'],

    data() {
        return {
            displayAfterTestBanner: true,
            displayBeforeTestBanner: true,
            displayBeforeIQCMRIBanner: true,
            displayFenrirSVCBanner: true,
            frontImageData:"",
            imagePaths: [],
            isLoadingImages: false,
            pageStep: null,
            pageTitle: null
        }
    },

    mounted() {
        this.loadDeviceForJob({
            jobId: this.jobId,
            deviceId: this.deviceId,
        }).then(() => {
            this.setCurrentStep({
                jobId: this.jobId,
                deviceId: this.deviceId,
                currentStep: this.$route.name,
            });
        });

        this.listImages();

        if (this.beforeOrAfter === "after") {
            this.pageStep = 8;
            this.pageTitle = "After";
        } else {
            this.pageStep = 2;
            this.pageTitle = "Before";
        }
    },

    computed: {
        ...mapGetters([
            "device",
            "isJobManager",
            "nextRepairStep",
            "prevRepairStep",
            "isRefurbOrMailIn"
        ]),

        /** Check if this is the before or after page */
        beforeOrAfter() {
            let page = this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1);

            if (page === 'after-pictures') {
                return "after";
            }

            return "before";
        },

        /** Change the test image type based on the page */
        esdOrOqc() {
            let page = this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1);

            if (page === 'after-pictures') {
                return "oqc";
            }

            return "esd";
        },

        /** Check if footer should be active */
        footerActive() {
            /** --TODO refactor on new release */
            return true;

            // let page = this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1);
            //
            // if (page === 'after-pictures') {
            //     if (!this.displayAfterTestBanner || this.isJobManager) {
            //         return true;
            //     }
            // }
            //
            // if (page === 'before-pictures') {
            //     if (!this.displayBeforeTestBanner || this.isJobManager) {
            //         return true;
            //     }
            // }
            //
            // return false;
        }
    },

    methods: {
        ...mapActions([
            "addDeviceImage",
            "displayToast",
            "loadDeviceForJob",
            "setCurrentStep"
        ]),

        uploadPhoto(type, elementId) {
            const filePicker = document.getElementById(elementId);

            if (!filePicker || !filePicker.files || filePicker.files.length <= 0) {
                this.displayToast({text: 'No file selected.', type: 'error'});
                return;
            }

            let self = this;
            new Compressor(filePicker.files[0], {
                quality: 0.6,
                mimeType: 'image/jpeg',
                maxWidth: 1920,
                maxHeight: 1920,
                success(result) {
                    const data = new FormData();
                    data.append('image', result);
                    data.set('device_id', self.deviceId);
                    data.set('type', type);

                    self.displayToast({text: 'File is being uploaded.', type: 'success'});

                    self.$http.post(
                        '/api/v4/upload-image',
                        data,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    ).then((response) => {
                        self.imagePaths.push(response.data.data);
                        self.displayImage(result);
                        self.displayToast({text: 'File successfully uploaded', type: 'success'});
                    }).catch((error) => {
                        console.log(error);
                        const message = error?.response?.statusText ?? 'Error uploading file';
                        self.displayToast({text: message, type: 'error'});
                    });

                },
                error() {
                    self.displayToast({text: 'Could not parse file.', type: 'error'});
                    filePicker.value = "";
                },
            });
        },

        /** Display the image just taken using base64data */
        displayImage(myFile) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                if (fileReader && myFile) {
                    fileReader.readAsDataURL(myFile);
                    fileReader.onload = () => {
                        resolve(fileReader.result);
                    };

                    fileReader.onerror = (error) => {
                        reject(error);
                    };
                } else {
                    reject('No file provided');
                }
            });
        },

        listImages() {
            this.isLoadingImages = true;

            this.$http.get(`/api/v4/images/${this.deviceId}`)
                .then((response) => {

                    const items = response.data.data;

                    const urls = items
                        .filter(item => !item.title.includes(self.beforeOrAfter))
                        .map(item => {
                            return {
                                path: item.path,
                                type: item.title
                            };
                        });

                    urls.forEach(image => {
                        if (image.type === 'after-fenrir-svc') {
                            this.displayFenrirSVCBanner = false;
                        }

                        if (image.type === 'after-oqc-results') {
                            this.displayAfterTestBanner = false;
                        }

                        if (image.type === 'before-esd-results') {
                            this.displayBeforeTestBanner = false;
                        }

                        if (image.type === 'before-iqc-mri') {
                            this.displayBeforeIQCMRIBanner = false;
                        }
                    });

                    this.imagePaths = urls;
                })
                .catch(error => {
                    console.error("Error fetching images:", error);
                    this.displayToast({
                        text: error?.response?.statusText ?? "Error fetching images",
                        type: "error"
                    });
                })
                .finally(() => {
                    this.isLoadingImages = false;
                });
        }


    }
}
</script>

<style scoped>

</style>